var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('dataplat-search',{ref:"dataplatSearch",on:{"submit":_vm.handleSubmit}}),(_vm.total !== 0)?_c('dataplat-content',{attrs:{"current":_vm.searchForm.page,"list":_vm.tableList,"total":_vm.total},on:{"changePage":_vm.handleChangePage,"changePageSize":_vm.handleChangePageSize}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }